export default __webpack_public_path__ + "static/media/single-project-page-04-img03.47f68c32.jpg";